/**
 * Result 组件的 emit 事件声明
 * 基于方案设计文档生成
 */
export const emits = [
  // Result 组件主要用于展示结果，不包含特定事件
  // 事件由插槽内的按钮等组件自行处理
];

